import { useMemo } from "react";
import { DataGridRequestParams } from "../types";

export interface PictusExportRequestParams {
  requestParams: DataGridRequestParams;
}

/**
 * Hook for exporting transactions in Pictus JSON format
 * 
 * Features:
 * - Returns function that provides request parameters for backend export
 * - Backend receives filters/sorting params and processes all matching transactions
 * - Eliminates need for frontend pagination and ID collection
 * 
 * @param requestParams - Data grid request parameters for filtering/sorting
 * @returns Object containing getExportParams function
 */
const usePictusJsonExport = (
  requestParams: DataGridRequestParams
) => {
  /**
   * Returns request parameters for backend export
   */
  const getExportParams = useMemo(
    () => (): PictusExportRequestParams => ({
      requestParams,
    }),
    [requestParams]
  );

  return { getExportParams };
};

export default usePictusJsonExport;
